'use client';
import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { useRouter } from 'next/navigation';

export default function StoreSearchBar() {
  const [query, setQuery] = useState('');
  const router = useRouter();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // Backend integration: GET /api/stores?search=query
    router.push(`/?search=${encodeURIComponent(query)}`);
  };

  return (
    <form onSubmit={handleSearch} className="flex max-w-xl mx-auto">
      <div className="flex-1 flex items-center bg-white rounded-l-xl px-4 gap-3 shadow-lg">
        <Search size={18} className="text-muted-foreground flex-shrink-0" />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search stores by name, category, or city..."
          className="flex-1 py-3.5 bg-transparent text-foreground placeholder:text-muted-foreground text-sm outline-none"
          aria-label="Search stores"
        />
      </div>
      <button
        type="submit"
        className="bg-primary text-primary-foreground px-6 py-3.5 rounded-r-xl font-semibold text-sm hover:bg-primary/90 active:scale-95 transition-all duration-150"
      >
        Search
      </button>
    </form>
  );
}